<h2 mat-dialog-title>{{ data.existingImagingStudy?.id ? 'Edit Imaging Study' : 'Add Imaging Study' }}</h2>

<div mat-dialog-content class="content">
    <form class="form" [formGroup]="form">
        <mat-form-field appearance="outline" class="full">
            <mat-label>Status</mat-label>
            <mat-select formControlName="status">
                @for (opt of statusOptions; track opt) {
                <mat-option [value]="opt">{{ opt }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full">
            <mat-label>Description</mat-label>
            <input matInput formControlName="description" placeholder="e.g., Chest X-ray" />
        </mat-form-field>

        <mat-form-field appearance="outline" class="full">
            <mat-label>Started</mat-label>
            <input matInput type="datetime-local" formControlName="started" />
            <mat-hint>Optional</mat-hint>
        </mat-form-field>

        <div class="images">
            <app-imaging-study-images [uploadLabel]="'Attach imaging photos (optional)'" [existingImages]="images"
                (imagesChanged)="images = $event" (cloudFiles)="onImagingCloudFiles($event)" [allowMultipleSelection]="true">
            </app-imaging-study-images>
        </div>
    </form>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="save()">Save</button>
</div>